import React from 'react';
import { observer } from 'mobx-react';
import { Checkbox } from '~/view/components/Controls/Checkbox/Checkbox';
import { localeStore } from '~/mobx/localesStore';
import { messageCampaignStore } from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignEditScreen/store/messageCampaignStore';
import { PostingTime } from '~/view/screens/MarketingScreen/screens/MessageCampaign/types';
import { defaultTime, fullWeek } from '~/constants/dateTime';
import CampaignTimeLater from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignEditScreen/components/MessageCampaignForm/MessageCampaignScheduled/CampaignTimeLater';
import CampaignTimeScheduled from '~/view/screens/MarketingScreen/screens/MessageCampaign/CampaignEditScreen/components/MessageCampaignForm/MessageCampaignScheduled/CampaignTimeScheduled';

const MessageCampaignScheduled: React.FC = observer(() => {
  const { form } = messageCampaignStore;

  const changeScheduledType = (type: any) => {
    messageCampaignStore.changeForm({
      postingType: type,
      settings: new Map(fullWeek.map((day) => [day, { weekday: day, startTime: defaultTime, isValid: true }])),
    });
  };

  return (
    <div className="d-flex flex-column full-width mt-10 mb-10 h-20">
      <div className="d-flex flex-row align-items-center full-height">
        <p className="family-medium text-size-18 mr-6 color-dark">{localeStore.t('marketing_mc_posting_time_block_hdr')}</p>
        <Checkbox
          type="radio"
          value={form.postingType === PostingTime.NOW}
          name={PostingTime.NOW}
          label={localeStore.t('marketing_mc_posting_time_block_choice_now')}
          onClick={changeScheduledType}
          className="mr-4"
          inputClassName="family-medium text-size-16"
        />
        <Checkbox
          type="radio"
          value={form.postingType === PostingTime.LATER}
          name={PostingTime.LATER}
          label={localeStore.t('marketing_mc_posting_time_block_choice_later')}
          onClick={changeScheduledType}
          className="mr-4"
          inputClassName="family-medium text-size-16"
        />
        <Checkbox
          type="radio"
          value={form.postingType === PostingTime.SCHEDULED}
          name={PostingTime.SCHEDULED}
          label={localeStore.t('marketing_mc_posting_time_block_choice_repeated')}
          onClick={changeScheduledType}
          className="mr-4"
          inputClassName="family-medium text-size-16"
        />

        {form.postingType === PostingTime.LATER && <CampaignTimeLater />}
        {form.postingType === PostingTime.SCHEDULED && <CampaignTimeScheduled />}
      </div>
      {!messageCampaignStore.validationErrors.time.isValid && (
        <p className="family-medium text-size-12 color-red mt-2">{messageCampaignStore.validationErrors.time.errorText}</p>
      )}
    </div>
  );
});

export default MessageCampaignScheduled;
